export type ClientStatus = 'active' | 'inactive' | 'debtor';

export const statusConfig: Record<ClientStatus, { label: string; cls: string }> = {
  active: { label: 'Активный', cls: 'bg-green-500/10 border-green-500/30 text-green-400' },
  inactive: { label: 'Неактивный', cls: 'bg-muted/40 border-border/30 text-muted-foreground' },
  debtor: { label: 'Должник', cls: 'bg-red-500/10 border-red-500/30 text-red-400' },
};

export function mapStatus(statusName: string): ClientStatus {
  if (statusName === 'Должник') return 'debtor';
  if (statusName === 'Активный') return 'active';
  return 'inactive';
}

export function mapCameraStatus(status: string): 'Активный' | 'Неактивный' {
  if (status === '1' || status === 'Активный') return 'Активный';
  return 'Неактивный';
}

export function cameraStatusToClient(status: string): ClientStatus {
  return mapCameraStatus(status) === 'Активный' ? 'active' : 'inactive';
}
